// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const cardSuccess = "StepIndicator__cardSuccess__PKhCJ";
export const checkStep = "StepIndicator__checkStep__bO-gR";
export const exclamation = "StepIndicator__exclamation__WzBRx";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const stepCompleted = "StepIndicator__stepCompleted__t9FJQ";
export const stepIndicator = "StepIndicator__stepIndicator__6Xsr5";
export const value = "StepIndicator__value__guPcF";